import {ViewOptions} from 'backbone';

import {assert} from 'Asserts';
import Protein from 'molbio/aa-sequences/AaSequence';
import ProteinActions from 'molbio/aa-sequences/AaSequenceActions';
import {ProteinUpdateData} from 'molbio/aa-sequences/AaSequenceDAO';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProteinInformationPanelView extends BasicInformationPanelView<Protein> {
  constructor(...args: Array<ViewOptions<Protein>>) {
    super(...args);
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.getDownloadInfo = this.getDownloadInfo.bind(this);
  }

  override saveModel(data: ProteinUpdateData): void {
    ProteinActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  deleteModel(): void {
    ProteinActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  getDownloadInfo(): Array<{url: string; title: string}> {
    const editUrl = this.model.editURL();
    assert(editUrl.slice(-5) === '/edit', 'Expected edit URL to end with /edit.');
    return [
      {
        url: editUrl.replace(/\/edit$/, '.fasta'),
        title: 'FASTA (.fasta)',
      },
      {
        url: editUrl.replace(/\/edit$/, '.gp'),
        title: 'GenPept (.gp)',
      },
    ];
  }
}

export default ProteinInformationPanelView;
